var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "10px",
    height: "10px"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M452,40h-24V0h-40v40H124V0H84v40H60C26.916,40,0,66.916,0,100v352c0,33.084,26.916,60,60,60h392    c33.084,0,60-26.916,60-60V100C512,66.916,485.084,40,452,40z M472,452c0,11.028-8.972,20-20,20H60c-11.028,0-20-8.972-20-20V188    h432V452z M472,148H40v-48c0-11.028,8.972-20,20-20h24v40h40V80h264v40h40V80h24c11.028,0,20,8.972,20,20V148z",
    fill: "#5d5d5d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 230,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 230,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 230,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 230,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 230,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 310,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 310,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 310,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 310,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 390,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 390,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 390,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 390,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 310,
    width: 40,
    height: 40,
    fill: "#5d5d5d"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null)), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null)), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null)), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null)), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null)), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null)), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null)), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null)), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null)), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null)), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null)));
};

export default __webpack_public_path__ + "static/media/calendar.eee8a06e.svg";
export { SvgCalendar as ReactComponent };